<app-agricola-navbar></app-agricola-navbar>

<div class="sis-app">
  <div class="sis-page queue-page">

    <!-- Back -->
    <button class="back-link" type="button" (click)="goBack()">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path d="M12 4l-6 6 6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>Atras</span>
    </button>

    <!-- Header -->
    <header class="queue-header">
      <h1 class="queue-title">Consultar reportes</h1>
      <p class="queue-subtitle">
        Ingresa el número de solicitud o presiona el botón de búsqueda para ver el estado de tus últimas solicitudes.
      </p>
    </header>

    <section class="sis-card queue-card">
      <!-- Search -->
      <div class="queue-search">
        <div class="field queue-search-field">
          <label class="field-label" for="queue-search">Número de solicitud de reporte</label>
          <input id="queue-search" class="form-input" type="text" [(ngModel)]="searchId" (keyup.enter)="search()">
        </div>
        <button class="apply-button" type="button" (click)="search()">Buscar</button>
      </div>

      <!-- Results header -->
      <div class="results-header">
        <h2 class="results-title">Resultados de busqueda</h2>
        <div class="results-meta" *ngIf="total">
          <span>Mostrando {{ filteredItems.length }} movimientos de {{ total }}</span>
          <div class="pager" *ngIf="totalPages > 1">
            <button class="pager-arrow" type="button" (click)="goToPage(page - 1)" [disabled]="page === 1" aria-label="Anterior">‹</button>
            <button
              class="pager-page"
              type="button"
              *ngFor="let n of pageNumbers"
              [class.is-current]="n === page"
              (click)="goToPage(n)">
              {{ n }}
            </button>
            <button class="pager-arrow" type="button" (click)="goToPage(page + 1)" [disabled]="page === totalPages" aria-label="Siguiente">›</button>
          </div>
          <select class="page-size" [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)" aria-label="Resultados por página">
            <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }}</option>
          </select>
        </div>
      </div>

      <p class="queue-error" *ngIf="errorMessage">{{ errorMessage }}</p>

      <div class="table-scroll">
        <table class="sis-table">
          <thead>
            <tr>
              <th>Número solicitud de reporte</th>
              <th>Nombre del reporte</th>
              <th>Fecha de solicitud</th>
              <th>Rango de fechas</th>
              <th>Descripción del estado</th>
              <th>Estado</th>
              <th>Descarga</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredItems">
              <td>{{ item.id }}</td>
              <td>{{ reportName(item) }}</td>
              <td>{{ item.created_time }}</td>
              <td>{{ dateRange(item) }}</td>
              <td>{{ statusDescription(item.status) }}</td>
              <td>
                <span class="sis-chip" [attr.data-status]="item.status">{{ statusLabel(item.status) }}</span>
              </td>
              <td>
                <button class="download-link" type="button" *ngIf="canDownload(item); else noDownload" (click)="download(item)">
                  Descargar
                </button>
                <ng-template #noDownload><span class="download-disabled">—</span></ng-template>
              </td>
            </tr>
            <tr *ngIf="!loading && !filteredItems.length">
              <td colspan="7" class="table-empty">No hay solicitudes de reporte.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

  </div>
</div>
